import { ContentHeader, Css, pageContentPaddingX, useModal } from "@homebound/beam";
import { CreateInvoiceTermsModal } from "./components/CreateInvoiceTermsModal";
import { InvoiceTermsTable } from "./components/InvoiceTermsTable";

export function InvoiceTermsPage() {
  const { openModal } = useModal();
  return (
    <>
      <ContentHeader
        title="Contract Invoice Terms"
        actions={[
          {
            label: "Create Invoice Terms",
            icon: "plus",
            variant: "secondary",
            onClick: () => openModal({ content: <CreateInvoiceTermsModal /> }),
          },
        ]}
        xss={{ ...pageContentPaddingX, ...Css.py4.$ }}
      />
      <InvoiceTermsTable />
    </>
  );
}
